<script setup lang="ts">
    import { CellContentAlignment, CellContentJustification } from "@/components/KTable/helpers";
    import KCell from "@/components/KTable/KCell.vue";
    import { computed, toRefs } from "vue";

    const props = defineProps<{
        data: unknown;
        alignContent?: CellContentAlignment;
        justifyContent?: CellContentJustification;
    }>();

    const { data } = toRefs(
        props as Readonly<{
            data: {
                salstid: number;
                id: string;
                current_bokad_huvudoperator_display: unknown;
                forberedelser: unknown;
                optid: number;
                avveckling: number;
                status: string;
                personId: string;
            };
        }>
    );

    const draggableData = computed(() => {
        // convert item.salstid that is in minutes to HH:MM
        const duration = data.value.salstid
            ? `${Math.floor(data.value.salstid / 60)}`.padStart(2, "0") +
              ":" +
              `${data.value.salstid % 60}`.padStart(2, "0")
            : "";

        return JSON.stringify({
            title: "",
            id: data.value.id,
            huvudoperator: data.value.current_bokad_huvudoperator_display,
            forberedelser: data.value.forberedelser,
            optid: data.value.optid,
            salstid: data.value.salstid,
            avveckling: data.value.avveckling,
            duration: duration,
            create: true,
        });
    });
</script>

<template>
    <KCell
        :class="[
            'cell-person-id',
            {
                draggable: ['Klar för operationsbokning', 'Avbokad'].includes(data.status),
                bokad: data.status === 'Bokad',
            },
        ]"
        :dataEvent="draggableData"
        :alignContent="alignContent"
        :justifyContent="justifyContent"
    >
        <template #content>
            <img v-if="data.status === 'Bokad'" src="@/assets/check_circle_black.svg" alt="Bokad" class="check" />
            <span>{{ data.personId }}</span>
        </template>
    </KCell>
</template>

<style scoped lang="scss">
    @import "@/style/variables";

    .cell-person-id {
        &.draggable {
            border-radius: $border-radius;
            border: 1px dashed #7cbed6;
            padding: 2px;
            width: fit-content;
            height: fit-content;

            span {
                display: flex;
                align-items: center;
                color: $color-active-dark;
                background-color: rgba(38, 148, 188, 0.2);
                border-left: 6px solid rgba(38, 148, 188, 0.5);
                padding: 2px 4px;
            }
        }

        &.bokad {
        }

        .check {
            margin-right: $icon-gap-default;
        }
    }
</style>
